var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.954 42.012c-5.648-8.431-14.462-13.378-32.088-23.303C101.08 11.49 89.349 5.049 72.529 2.063 61.047.01 51.087-1.733 40.41 3.152 30.17 7.85 24.8 16.157 19.308 24.62c-5.928 9.147-8.317 16.677-12.91 31.175C1.836 70.201-.429 77.42.068 84.326c.806 11.108 6.02 18.668 13.685 31.176 6.672 10.889 11.73 19.134 20.668 25.637 13.003 9.458 26.595 9.707 53.035 9.832 26.782.124 40.157.186 49.312-7.25 13.934-11.263 15.113-30.428 16.51-53.577 1.148-18.543 2.172-33.975-7.355-48.132h.031zm1.334 46.172-5.679 34.1c-1.769 10.703-9.993 19.073-18.713 18.979a190.985 190.985 0 0 1-29.978 2.116c-12.289-.093-23.337-1.338-32.833-2.956-1.583-.062-9.744-.466-15.889-7.373-4.034-4.543-6.392-10.797-6.02-17.704l2.39-44.803c.837-15.712 13.25-26.135 26.874-23.024a317.235 317.235 0 0 0 35.067 10.05 291.392 291.392 0 0 0 32.089 5.351c1.52.56 7.354 2.552 10.551 9.054 2.265 4.574 3.134 10.361 2.141 16.241v-.03z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.228 122.129c-6.051-.467-10.613-6.285-10.055-13.099l2.359-29.558c.59-7.249 6.269-12.258 12.537-11.138 6.114 1.089 10.427 7.623 9.745 14.56l-2.824 28.283c-.652 6.533-5.866 11.387-11.762 10.952zM121.036 123.809c-4.19-.311-7.076-4.791-6.393-10.049l3.01-22.744c.745-5.538 4.903-9.459 9.186-8.68 4.22.746 6.92 5.724 6.114 11.044l-3.228 21.873c-.745 5.04-4.624 8.867-8.72 8.556h.031zM99.375 124.213c7.914.777 10.582.155 10.893 1.182.496 1.68-5.4 6.503-11.638 6.036-6.61-.498-11.854-6.752-11.016-8.338.527-.996 3.227.28 11.792 1.12h-.03z",
    fill: "#0F56D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 79.912,
    y1: 0,
    x2: 47.937,
    y2: 193.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7694FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1337B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9205a87f85109671d168c8552feddfcc.svg";
export { ForwardRef as ReactComponent };